// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Semaglutide + B6 Initial 09.17.26" (dd65b71f-30bc-4ade-a3bb-d96f8a3cdddf). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiSemaglutideB6InitialAnswerField } from './questions';

export const mdiSemaglutideB6Initial: FormType<mdiSemaglutideB6InitialAnswerField> =
  {
    name: 'Semaglutide + B6 Initial',
    validityLength: 25,
    questions: [
      {
        key: 'mdiSemaglutideB6Initial_state',
        next: {
          switch: [
            {
              condition: { 'mdiSemaglutideB6Initial_state.ms': true },
              key: 'mdiSemaglutideB6Initial_considerTreatmentGlp1AppropriateReasons'
            },
            {
              condition: { 'mdiSemaglutideB6Initial_state.la': true },
              key: 'mdiSemaglutideB6Initial_considerTreatmentGlp1AppropriateReasons'
            }
          ],
          els: 'mdiSemaglutideB6Initial_goalWeight'
        }
      },
      'mdiSemaglutideB6Initial_considerTreatmentGlp1AppropriateReasons',
      'mdiSemaglutideB6Initial_goalWeight',
      {
        key: 'mdiSemaglutideB6Initial_takingPrescriptionMedications',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.other_drug_not_listed':
                  true
              },
              key: 'mdiSemaglutideB6Initial_otherMedicationTaking'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.compounded_semaglutide':
                  true
              },
              key: 'mdiSemaglutideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.compounded_tirzepatide':
                  true
              },
              key: 'mdiSemaglutideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.wegovy_zepbound_mounjaro_ozempic_trulici':
                  true
              },
              key: 'mdiSemaglutideB6Initial_typeDrugInformationFoundLabel'
            }
          ],
          els: 'mdiSemaglutideB6Initial_labTestsCompletedWithinLast'
        }
      },
      {
        key: 'mdiSemaglutideB6Initial_otherMedicationTaking',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.compounded_semaglutide':
                  true
              },
              key: 'mdiSemaglutideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.compounded_tirzepatide':
                  true
              },
              key: 'mdiSemaglutideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.wegovy_zepbound_mounjaro_ozempic_trulici':
                  true
              },
              key: 'mdiSemaglutideB6Initial_typeDrugInformationFoundLabel'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.other_drug_not_listed':
                  true
              },
              key: 'mdiSemaglutideB6Initial_takePictureCurrentPrescriptionMedication'
            }
          ],
          els: 'mdiSemaglutideB6Initial_labTestsCompletedWithinLast'
        }
      },
      {
        key: 'mdiSemaglutideB6Initial_typeDrugInformationFoundLabel',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.compounded_semaglutide':
                  true
              },
              key: 'mdiSemaglutideB6Initial_takePictureCurrentPrescriptionMedication'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.compounded_tirzepatide':
                  true
              },
              key: 'mdiSemaglutideB6Initial_takePictureCurrentPrescriptionMedication'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.wegovy_zepbound_mounjaro_ozempic_trulici':
                  true
              },
              key: 'mdiSemaglutideB6Initial_takePictureCurrentPrescriptionMedication'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.other_drug_not_listed':
                  true
              },
              key: 'mdiSemaglutideB6Initial_takePictureCurrentPrescriptionMedication'
            }
          ],
          els: 'mdiSemaglutideB6Initial_labTestsCompletedWithinLast'
        }
      },
      {
        key: 'mdiSemaglutideB6Initial_takePictureCurrentPrescriptionMedication',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.wegovy_zepbound_mounjaro_ozempic_trulici':
                  true
              },
              key: 'mdiSemaglutideB6Initial_dateLastDose'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.compounded_semaglutide':
                  true
              },
              key: 'mdiSemaglutideB6Initial_dateLastDose'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.compounded_tirzepatide':
                  true
              },
              key: 'mdiSemaglutideB6Initial_dateLastDose'
            },
            {
              condition: {
                'mdiSemaglutideB6Initial_takingPrescriptionMedications.other_drug_not_listed':
                  true
              },
              key: 'mdiSemaglutideB6Initial_dateLastDose'
            }
          ],
          els: 'mdiSemaglutideB6Initial_labTestsCompletedWithinLast'
        }
      },
      'mdiSemaglutideB6Initial_dateLastDose',
      {
        key: 'mdiSemaglutideB6Initial_labTestsCompletedWithinLast',
        next: {
          condition: {
            'mdiSemaglutideB6Initial_labTestsCompletedWithinLast.yes': true
          },
          key: 'mdiSemaglutideB6Initial_doctorOnlyNeedsSeeCholesterol',
          els: 'mdiSemaglutideB6Initial_highCholesterol'
        }
      },
      'mdiSemaglutideB6Initial_doctorOnlyNeedsSeeCholesterol',
      'mdiSemaglutideB6Initial_highCholesterol',
      'mdiSemaglutideB6Initial_chronicPancreatitisPrevious',
      'mdiSemaglutideB6Initial_historyKidneyFailure',
      'mdiSemaglutideB6Initial_likePrescriptionNauseaMedicationSent',
      'mdiSemaglutideB6Initial_readInformationAboutPersonalizedTreatment',
      'mdiSemaglutideB6Initial_importantClickAttachedLinkReview',
      'mdiSemaglutideB6Initial_heresFirstMessageDoctorIntroduce',
      'mdiSemaglutideB6Initial_complete'
    ]
  };
